import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import {Grid, Box, Button} from '@material-ui/core';
import {TextField, LinearProgress, Checkbox} from '@mui/material';
//import {TextField, FormControl, Stack, Snackbar, Alert, LinearProgress, Radio, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';
import SaveIcon from '@mui/icons-material/Save';
// import Select from '@mui/material/Select';
// import MenuItem from '@mui/material/MenuItem';
// import FormControlLabel from '@mui/material/FormControlLabel';
// import Checkbox from '@mui/material/Checkbox';
// import { makeStyles } from "@material-ui/core/styles";
import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import InputAdornment from '@mui/material/InputAdornment';
import ImageIcon from '@mui/icons-material/Image';
import moment from 'moment';
import FileManagement from '../components/FileManagement';
import TagsOptions from '../components/TagsOptions';
import CategoryTreeview from './CategoryTreeview';
import axios from 'axios';
import { useSelector } from 'react-redux';
import * as env from '../utils/EnvVars';
import { Editor } from '@tinymce/tinymce-react';
// import $ from 'jquery';

// window.$ = $;
// window.tinymce = require('tinymce');  // Expose the TinyMCE to the window.

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

// const useStyles = makeStyles({
//   paper: {
//     fontSize: '12px !important',    
//   }
// });

var vertical='top',horizontal='center';

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const CustomizedDialogs = React.forwardRef((props, ref) => {  
  const editorRef = React.useRef(null);
  const childRefFM = React.useRef();
  ///const classes = useStyles();
  const userObj = useSelector(state => state.userDetails);
  const [open, setOpen] = React.useState(false); 
  const [pageLoading, setPageLoading] = React.useState(false);
  const [severityAlert, setSeverityAlert] = React.useState("error");
  const [showAlert, setShowAlert] = React.useState(false);
  const [alertMessage, setAlertMessage] = React.useState("");
  const [savingBtn, setSavingBtn] = React.useState(false);

  const [categoryTreeview, setCategoryTreeview] = React.useState([]);

  const [categoryId, setCategoryId] = React.useState(0);
  const [categoryName, setCategoryName] = React.useState("");
  const [categoryUrl, setCategoryUrl] = React.useState("");
  const [channelId, setChannelId] = React.useState(0);
  const [channelName, setChannelName] = React.useState("");  
  
  const [postTitle, setPostTitle] = React.useState("");
  const [postUrl, setPostUrl] = React.useState("");
  const [postSubTitle, setPostSubTitle] = React.useState("");
  const [postDescription, setPostDescription] = React.useState("");
  const [postShortDescription, setPostShortDescription] = React.useState("");
  const [seoTitle, setSeoTitle] = React.useState("");
  const [seoDescription, setSeoDescription] = React.useState("");
  const [seoKeywords, setSeoKeywords] = React.useState("");
  const [seoTags, setSeoTags] = React.useState("");
  const [tags, setTags] = React.useState([]);
  const [postImage, setPostImage] = React.useState("");
  const [source, setSource] = React.useState("");

  const [backChecked, setBackChecked] = React.useState(true);

  const handleBackChkChange = (event) => {
    setBackChecked(event.target.checked);
  };

  var myCurrentDate=new Date();
	var myPastFromDate=new Date(myCurrentDate);
  myPastFromDate.setDate(myPastFromDate.getDate() - getRandomInt(3, 7));
  ///myPastFromDate.setDate(myPastFromDate.getDate() - 1);
	const [displayDate, setDisplayDate] = React.useState(moment(myPastFromDate).format('YYYY-MM-DD'));


  function getRandomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  React.useImperativeHandle(ref, () => ({
    handleClickOpen(){
      setOpen(true);
    }
  }));
  
  const handleClose = () => {
    setOpen(false);
  };

  function hideAlert(){
		setShowAlert(false);
	}

  React.useEffect(() => {	
    setSavingBtn(false);
    if(localStorage.getItem('categoryTreeview')!== null){
      setCategoryTreeview(JSON.parse(localStorage.getItem('categoryTreeview')));
    }else if(open && userObj.obj.loginId){
      getApiData();
    }

    if(open && props.dataObj && props.dataObj.autoId>0){
      setCategoryId(props.dataObj.categoryId);
      setCategoryName(props.dataObj.categoryName);
      setCategoryUrl(props.dataObj.categoryUrl);

      if(props.dataObj.channelId){
        setChannelId(props.dataObj.channelId);
      }else{
        setChannelId(0);
      }
      setChannelName(props.dataObj.channelName); 
      setPostTitle(props.dataObj.postTitle);
      setPostUrl(props.dataObj.postUrl);
      setPostSubTitle(props.dataObj.postSubTitle);
      setPostShortDescription(props.dataObj.postShortDescription);
      setPostDescription(props.dataObj.postDescription);
      setPostImage(props.dataObj.postImage);
      setSeoTitle(props.dataObj.seoTitle);
      setSeoDescription(props.dataObj.seoDescription);
      setSeoKeywords(props.dataObj.seoKeywords);
      setSeoTags(props.dataObj.seoTags);
      setSource(props.dataObj.source);

      if(props.dataObj.tags){
        setTags(props.dataObj.tags.split(','));
      }

      if(props.dataObj.displayDate){
        let dateArr = props.dataObj.displayDate.split("-");
        setDisplayDate(moment(new Date(dateArr[2]+"-"+dateArr[1]+"-"+dateArr[0])).format('YYYY-MM-DD'))
      }

    }else{
      resetForm();

    }
	}, [open,userObj,props.dataObj]);

  async function getApiData(){
      let axiosHeader = {
        headers:{
          'Content-Type': 'multipart/mixed',
          'loginId': userObj.obj.loginId,
          'token': userObj.obj.token,
          'device': 'web'
        }
      }; 
      setPageLoading(true);
			axios.get(env.API_URL+'/admin/posts-form-one', axiosHeader)
			   .then(response => {
          setPageLoading(false);
				 if(response.data && response.data.responseTxt==="InvalidToken"){ 
					  window.location.href='login';
				 }else if(response.data.responseTxt==="success"){	
            if(response.data?.obj?.dataOne){		
              ///document.write(JSON.stringify(response.data?.obj?.dataOne));		 
              setCategoryTreeview(response.data?.obj?.dataOne);
              ///setChannelList(response.data?.obj?.dataTwo);
              localStorage.setItem('categoryTreeview', JSON.stringify(response.data?.obj?.dataOne));
            } 
				 }	 				
			})
	}

  function resetForm(){
    //setCategoryId(0);
      //setCategoryName("");
      //setChannelId(0);
      //setChannelName("");
      //setCategoryUrl("");
      setPostTitle("");
      setPostUrl("");
      setPostSubTitle("");
      setPostShortDescription("");
      setPostDescription("");
      setSeoTitle("");
      setSeoDescription("");
      setPostImage("");
      setSeoKeywords("");
      setSeoTags("");
      setTags([]);
      setDisplayDate(moment(myPastFromDate).format('YYYY-MM-DD'));
      setSource("");
  }

  // function cleanHtml(val) {
  //   val = val
  //     .replace(/\sdata-start="[^"]*"/g, "")
  //     .replace(/\sdata-end="[^"]*"/g, "")
  //     .replace(/<hr\s*\/?>/gi, "")
  //     .replace(/📌/g, "")
  //     .replace(/⚠️/g, "")
  //     .replace(/<blockquote>/gi, "<q>")
  //     .replace(/<\/blockquote>/gi, "</q>");
  //    val = val.replace(/<q>([\s\S]*?)<\/q>/gi, (match, content) => {
  //       // Remove any <p> tags inside <q> and trim
  //       const cleaned = content.replace(/<\/?p>/gi, "").trim();
  //       return `<p><q>${cleaned}</q></p>`;
  //     });
  //   return val;
  // }

  function cleanHtml(val) {
  if (!val) return "";

  // 1. Remove data-start and data-end attributes
  val = val
    .replace(/\sdata-start="[^"]*"/g, "")
    .replace(/\sdata-end="[^"]*"/g, "");

  // 2. Remove <hr> tags
  val = val.replace(/<hr\s*\/?>/gi, "");

  // 3. Remove emojis
  val = val.replace(/📌/g, "").replace(/⚠️/g, "");

  // 4. Replace <blockquote> with <q>
  val = val.replace(/<blockquote>/gi, "<q>").replace(/<\/blockquote>/gi, "</q>");

  // 5. Wrap <q> in <p> and remove inner <p>
  val = val.replace(/<q>([\s\S]*?)<\/q>/gi, (match, content) => {
    // Remove any <p> inside <q> and trim
    const cleaned = content.replace(/<\/?p>/gi, "").trim();
    return `<p><q>${cleaned}</q></p>`;
  });

  val = val.replace(/<p>(&nbsp;|\s)*<\/p>/gi, "");

  return val;
}


	function saveData(){  
    if(!categoryName){
      setSeverityAlert("error");
      setShowAlert(true);
      setAlertMessage("Select category");			
      return false;
    } 
    if(!postTitle){
      setSeverityAlert("error");
      setShowAlert(true);
      setAlertMessage("Enter post title");			
      return false;
    } 
    if(!postUrl){
      setSeverityAlert("error");
      setShowAlert(true);
      setAlertMessage("Enter post URL");			
      return false;
    } 
    if(!postDescription){
      setSeverityAlert("error");
      setShowAlert(true);
      setAlertMessage("Enter post description");			
      return false;
    }  

		if(categoryName && categoryName.length>1 && postTitle && postTitle.length>1 && postUrl && postUrl.length>1){ 
			let axiosHeader = {
				headers:{
				  'Content-Type': 'multipart/mixed',
				  'loginId': userObj.obj.loginId,
				  'token': userObj.obj.token,
				  'device': 'web'
				}
			};
			const data = new FormData();
      if(props.dataObj && props.dataObj.autoId>0){
        data.append('id', props.dataObj.autoId);
      }
      data.append('categoryName', categoryName);      
      data.append('categoryId', categoryId);
      data.append('categoryUrl', categoryUrl);
      data.append('channelId', channelId);
      data.append('channelName', channelName);

      data.append('postTitle', postTitle);
      data.append('postUrl', postUrl);
      data.append('postSubTitle', postSubTitle);
      data.append('postShortDescription', postShortDescription);
      data.append('postDescription', cleanHtml(postDescription));

      data.append('postImage', postImage);

      ///data.append('seoTitle', seoTitle);
      data.append('seoTitle', postTitle);
      data.append('seoDescription', seoDescription);
      data.append('seoKeywords', seoKeywords);
      data.append('seoTags', seoTags);
      
      if(tags && tags.length>0){
        data.append('tags', tags.join(','));
      }else{
        data.append('tags', '');
      }
    
      data.append('displayDate', displayDate);
      data.append('source', source);

      let apiURL='/admin/posts-create';
      let myMessage="Post has been created.";
      if(props.dataObj && props.dataObj.autoId>0){
          apiURL='/admin/posts-update';
          myMessage="Post has been updated.";
      }
      setSavingBtn(true);  
			axios.post(env.API_URL+apiURL, data, axiosHeader)
			.then((response) => {
        setSavingBtn(false);
				///console.log("RESPONSE RECEIVED: ", response.data.responseTxt);
				if(response.data.responseTxt==="success"){
          setSeverityAlert("success");
          setAlertMessage(myMessage);
          setShowAlert(true);
          if(backChecked===true){
            resetForm();
          }else{
            setOpen(false);
            props.reload();	
          }
					return false;
				}else{
          setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage("This post could not be saved.");			
					return false;
				}
			})
			.catch((error) => {
				console.log("AXIOS ERROR: ", error);
			})	
		}		
	}

  

  function selectTreeNode(obj) {
    if(obj && obj.categoryId>0){
        setCategoryId(obj.categoryId);
        setCategoryName(obj.categoryName);
        setCategoryUrl(obj.categoryUrl);
        setChannelId(obj.channelId);
        setChannelName(obj.channelName);
    }else{
      setCategoryId(0);
      setCategoryName("");
      setCategoryUrl("");
      setChannelId(0);
      setChannelName("");
    }   
  }

  function selectedTags(arr) {
    setTags(arr);
  }

  const selectFile = () => {
		childRefFM.current.handleClickOpen();
	}

  function getFileData(obj){
    setPostImage(obj.fileName);
  }

  function handlePostUrl(val){
    if(val && val.length>0){
      val = val.trim().toLowerCase().replaceAll('&','');      
      val = val.replaceAll(',','');
      val = val.replaceAll(':','');
      val = val.replaceAll('(','').replaceAll(')','');
      val = val.replaceAll(' ','-').replaceAll('--','-');
      val = val.replaceAll('--','-');
      val = val.replaceAll("'",'');
      val = val.replaceAll("’",''); 
      val = val.replaceAll("?",'');
      val = val.replaceAll(".",'');    
      val = val.replace(/[^a-zA-Z0-9-]/g, ""); 
      setPostUrl(val);

    }else{
      setPostUrl("");
    }
    
  }
  
  return (
    <>
      <Dialog fullWidth maxWidth="lg" onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle style={{marginBottom:'-30px'}} onClose={handleClose}></DialogTitle>
          <DialogContent >
            <Grid item   md={12} xs={12} className="test-instructions" >
                  <div className="btmbdrgry"><h3>{(props.dataObj && props.dataObj.autoId>0)?<>Edit</>:<>New</>} Post</h3></div>
                  {pageLoading?<LinearProgress />:null}
            <Box mt={1}>
							<Grid container spacing={2}>
                <Grid item md={4} xs={12}>
                    {(categoryTreeview && categoryTreeview.length>0)?<CategoryTreeview treeviewList={categoryTreeview} selectTreeNode={selectTreeNode} />:null}
                </Grid>
								<Grid item md={8} xs={12}>      
                      <table style={{backgroundColor:'#000000',width:'100%' }} cellSpacing="1" cellPadding="3" >
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td>Category Name</td>
                            <td>{(categoryName && categoryName.length>0)?<span style={{fontWeight:'bold',color:'#0000FF',fontSize:15}} >{categoryName}</span>:<span style={{fontWeight:'bold',color:'#FF0000'}} >Select category from left side</span>}</td>                            
                        </tr>
                        {(channelName && channelName.length>0)?
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td>Channel Name</td>
                            <td>{channelName}</td>                            
                        </tr>
                        :null}

                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td colSpan={2} >
                            <TextField label="Title" onChange={event => setPostTitle(event.target.value)} value={postTitle} placeholder={'Title'} sx={{width:'99%',fontSize: 10}} variant="standard" inputProps={{maxLength: 200}} />
                            </td>                            
                        </tr>
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td colSpan={2} >
                            <TextField label="URL" onChange={event => handlePostUrl(event.target.value)} value={postUrl} placeholder={'URL'} sx={{width:'99%',fontSize: 10}} variant="standard" inputProps={{maxLength: 180}} />
                            </td>                            
                        </tr>
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td colSpan={2} >
                            <TextField label="Sub Title" onChange={event => setPostSubTitle(event.target.value)} value={postSubTitle} placeholder={'Sub title'} sx={{width:'99%',fontSize: 10}} variant="standard" inputProps={{maxLength: 140}} />
                            </td>                            
                        </tr>
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td colSpan={2} >
                            <TextField label="Short Description" onChange={event => setPostShortDescription(event.target.value)} value={postShortDescription} placeholder={'Short Description'} sx={{width:'99%',fontSize: 10}} variant="standard" inputProps={{ maxLength: 200 }} />
                            </td>                            
                        </tr>
                        {/* <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td colSpan={2} >
                            <TextField label="SEO Meta Title" onChange={event => setSeoTitle(event.target.value)} value={seoTitle} placeholder={'Enter seo title'} sx={{width:'99%',fontSize: 10}} variant="standard" inputProps={{maxLength: 140}} />
                            </td>                            
                        </tr> */}
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td colSpan={2} >
                            <TextField label="SEO Meta Description" onChange={event => setSeoDescription(event.target.value)} value={seoDescription} placeholder={'Enter seo description'} sx={{width:'99%',fontSize: 10}} variant="standard" inputProps={{maxLength: 250}} />
                            </td>                            
                        </tr>
                        {/* <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td colSpan={2} >
                            <TextField label="SEO Meta Keywords" onChange={event => setSeoKeywords(event.target.value)} value={seoKeywords} placeholder={'Enter seo keywords'} sx={{width:'99%',fontSize: 10}} variant="standard" inputProps={{maxLength: 250}} />
                            </td>                            
                        </tr> */}
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td colSpan={2} >
                            <TextField 
                              label="Image" 
                              onChange={event => setPostImage(event.target.value)} 
                              value={postImage} 
                              placeholder={'Select image'} 
                              sx={{width:'99%',fontSize: 10}} 
                              variant="standard"
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <ImageIcon style={{cursor:'pointer'}} onClick={()=>{selectFile()}} />
                                  </InputAdornment>
                                ),
                                }}
                              />
                            </td>                            
                        </tr>
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td colSpan={2} >
                            {/* <TextField label="Description" onChange={event => setPostDescription(event.target.value)} value={postDescription} placeholder={'Details'} sx={{width:'99%',fontSize: 10}} rows={10} variant="standard" multiline /> */}
                            
                            <Editor 
                                onEditorChange={(newText) => setPostDescription(newText)}
                                value={postDescription}
                                onInit={(evt, editor) => editorRef.current = editor}
                                //value={details}
                                //initialValue = { 'asdfasdf' }                                    
                                ///tinymceScriptSrc={process.env.PUBLIC_URL + '/tinymce/tinymce.min.js'}
                                init={{
                                // external_plugins: {
                                //   'tiny_mce_wiris' : `${window.location.href}/node_modules/@wiris/mathtype-tinymce6/plugin.min.js`
                                // },
                                  height: 800,
                                  selector: 'textarea',
                                  menubar: true,
                                  branding: false,
                                  promotion: false,
                                  //link_context_toolbar: true,
                                  // quickbars_insert_toolbar: true,
                                  //trapFocus: false,
                                  //relative_urls : false,
                                  //remove_script_host: true,                                  
                                  plugins: "advlist lists table paste textcolor colorpicker tabfocus link preview image",
                                  toolbar: "tiny_mce_wiris_formulaEditor tiny_mce_wiris_formulaEditorChemistry table fontsizeselect bold italic underline forecolor backcolor bullist numlist link preview code", 
                                  imagetools_toolbar: "rotateleft rotateright | flipv fliph | editimage",
                                  convert_urls: false,
                                  draggable_modal: true,                                  
                                  htmlAllowedTags:  ['.*'],
                                  htmlAllowedAttrs: ['.*'],
                                  extended_valid_elements: '*[.*]',
                                  a11y_advanced_options: true,
                                  // image_list: [
                                  //   {title: 'My image 1', value: 'https://www.example.com/my1.gif'},
                                  //   {title: 'My image 2', value: 'http://www.moxiecode.com/my2.gif'}
                                  //   ],
                                    // automatic_uploads: true,
                                    // images_upload_url: env.API_URL+'/admin-files-upload',
                                    //   images_reuse_filename: true,
                                    //   images_file_types: 'jpeg,jpg,jpe,jfi,jif,jfif,png,gif,bmp,webp,svg',
                                  // plugins: [
                                  //   'quickbars advlist autolink lists link image charmap print preview anchor',
                                  //   'searchreplace visualblocks code fullscreen',
                                  //   'insertdatetime media table paste code help wordcount searchreplace'
                                  // ], 
                                  // table_toolbar: 'tableprops tabledelete | tableinsertrowbefore tableinsertrowafter tabledeleterow | tableinsertcolbefore tableinsertcolafter tabledeletecol',
                                  // toolbar: 'undo redo | styles | formatselect | searchreplace | ' +
                                  // 'bold italic underline backcolor | link image | alignleft aligncenter ' +
                                  // 'alignright alignjustify | bullist numlist outdent indent | ' +
                                  // 'removeformat | table tabledelete | tableprops tablerowprops tablecellprops | tableinsertrowbefore tableinsertrowafter tabledeleterow | tableinsertcolbefore tableinsertcolafter tabledeletecol | help',
                                  content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
                                }}
                              />

                            
                            </td>                            
                        </tr>
                        
                        
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td colSpan={2} >
                            <TextField label="SEO Meta Tags" onChange={event => setSeoTags(event.target.value)} value={seoTags} placeholder={'Enter seo tags'} sx={{width:'99%',fontSize: 10}} variant="standard" />
                            </td>                            
                        </tr>
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td colSpan={2} >
                              <div style={{marginTop:10}}>
                                <TagsOptions defaultValues={tags} selectedTags={selectedTags} options={[{title:'Trending'},{title:'Featured'},{title:'Popular'},{title:'Latest'}]} />
                              </div>
                            </td>                            
                        </tr>
                        {/* <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td colSpan={2} >
                                <Select  
                                  label="Country"
                                  style={{width:'100%'}}
                                  classes={{ paper: classes.paper }}
                                  labelId="select-class-labela"
                                  id="select-classa"
                                  value={channelId+"$"+channelName}									
                                  onChange={event => handleChannel(event.target.value)}
                                  variant="standard"
                                >
                                    <MenuItem value={"0$"} >Select Country</MenuItem> 
                                    {(channelList && channelList.length>0)?
                                      channelList.map((myRow,key)=>(
                                        <MenuItem key={'mtk'+key} value={myRow.autoId+"$"+myRow.channelName} >{myRow.channelName}</MenuItem> 
                                      )):null}
                                </Select>
                            </td>                            
                        </tr> */}
                        {/* <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td colSpan={2} >
                                <Select 
                                  label="State"
                                  style={{width:'100%'}}
                                  classes={{ paper: classes.paper }}
                                  labelId="select-class-labela"
                                  id="select-classa"
                                  value={channelId+"$"+channelName}									
                                  onChange={event => handleChannel(event.target.value)}
                                  variant="standard"
                                >
                                    <MenuItem value={"0$"} >Select State</MenuItem> 
                                    {(channelList && channelList.length>0)?
                                      channelList.map((myRow,key)=>(
                                        <MenuItem key={'mtk'+key} value={myRow.autoId+"$"+myRow.channelName} >{myRow.channelName}</MenuItem> 
                                      )):null}
                                </Select>
                            </td>                            
                        </tr> */}
                        {/* <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td colSpan={2} >
                                <Select 
                                  label="City"
                                  style={{width:'100%'}}
                                  classes={{ paper: classes.paper }}
                                  labelId="select-class-labela"
                                  id="select-classa"
                                  value={channelId+"$"+channelName}									
                                  onChange={event => handleChannel(event.target.value)}
                                  variant="standard"
                                >
                                    <MenuItem value={"0$"} >Select City</MenuItem> 
                                    {(channelList && channelList.length>0)?
                                      channelList.map((myRow,key)=>(
                                        <MenuItem key={'mtk'+key} value={myRow.autoId+"$"+myRow.channelName} >{myRow.channelName}</MenuItem> 
                                      )):null}
                                </Select>
                            </td>                            
                        </tr> */}
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td colSpan={2} >
                            <TextField type="date" label='Display Date' onChange={event => setDisplayDate(event.target.value)} value={displayDate} fullWidth size='small' style={{marginTop:10}} variant="outlined"  />
                            </td>                            
                        </tr>

                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td colSpan={2} >
                            <TextField label="Source" onChange={event => setSource(event.target.value)} value={source} placeholder={'Source'} sx={{width:'99%',fontSize: 10}} variant="standard" />
                            </td>                            
                        </tr>

                      </table>

                      <Checkbox
                        checked={backChecked}
                        onChange={handleBackChkChange}
                        slotProps={{
                          input: { 'aria-label': 'controlled' },
                        }}
                      />
                      Return Back After Save

                      <Box mt={2}>
                          <Button onClick={() => {handleClose()}} style={{marginRight:12}} size="small" variant="outlined" >Cancel</Button>
                          {savingBtn?                
                          <LoadingButton loading loadingPosition="start" startIcon={<SaveIcon />} style={{backgroundColor:'#008000',color:'#FFF',marginRight:10}} size="small" variant="outlined" >Saving...</LoadingButton>
                          :<Button onClick={() => {saveData()}} size="small" variant="contained" style={{backgroundColor:'#008000',color:'#FFF',marginRight:10}} >Save</Button>
                          } 
								      </Box>
                </Grid>
              </Grid>
            </Box>              
                  
            </Grid>
          </DialogContent>
      </Dialog>
      
        <Stack spacing={2} sx={{ width: '100%' }}>
					<Snackbar open={showAlert} autoHideDuration={6000} onClose={hideAlert} anchorOrigin={{vertical,horizontal}}  >
						<Alert onClose={hideAlert} variant="filled" severity={severityAlert} sx={{ width: '100%' }}>
							{alertMessage}
						</Alert>
					</Snackbar>
				</Stack>

        <FileManagement setFileData={getFileData} ref={childRefFM} />

    </>
  );

});

export default CustomizedDialogs;